
<template>
  <swiper
    class="clickable"
    :modules="modules"
    :speed="6000"
    :slides-per-view="2"
    :space-between="24"
    :loop="true"
    :autoplay="{ delay: 0, disableOnInteraction: false,}"
    :navigation = "{ nextEl:'.businesslist__controll'}"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <figure><img :src="item.pic" :alt="item.name"></figure>
      <div>
        <h3>{{ item.name }}</h3>
        <dl>
          <dt v-html="item.company"></dt>
          <dd v-html="item.job"></dd>
        </dl>
        <p v-html="item.text"></p>
        <div class="sns">
          <a rel="noreferrer noopener" :href="item.x" target="_blank" aria-label="X" v-if="item.x">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
          </a>
          <a rel="noreferrer noopener" :href="item.facebook" target="_blank" aria-label="Facebook" v-if="item.facebook">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg>
          </a>
          <a rel="noreferrer noopener" :href="item.insta" target="_blank" aria-label="instagram" v-if="item.insta">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
          </a>
          <a rel="noreferrer noopener" :href="item.youtube" target="_blank" aria-label="Youtube" v-if="item.youtube">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>
          </a>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  height: auto;
  font-size: .92rem;
  background: rgba(module.$white,.04);
  padding: 2rem;
  display: grid;
  grid-template-columns: 9.6rem 1fr;
  gap: 2rem;
  border-radius: 1rem;
  > *{
    align-self: center;
  }
  figure{
    padding: 100% 0 0;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  h3{
    font-size: 1.24rem;
    margin: 0 0 .64rem;
    &:before{
      content: '●';
      color: module.$base;
      display: inline-block;
      margin: 0 .4rem 0 0;
      transform: scale(.8);
      transform-origin: left center;
    }
  }
  dl{
    font-size: 1rem;
    display: grid;
    grid-template-columns: auto 1fr;
    margin: 0 0 .8rem;
    dt{
      &:after{
        content: '/';
        display: inline-block;
        margin: 0 .4rem;
        opacity: .16;
      }
    }
  }
  .sns{
    @include module.flex();
    align-items: center;
    justify-content: flex-start;
    margin: 1rem 0 0;
    a{
      background: rgba(module.$white, .08);
      width: 2.8rem;
      height: 2.8rem;
      @include module.flex();
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin: 0 .64rem 0 0;
      transition: all 200ms module.$ease;
      &:last-of-type{
        margin: 0;
      }
      svg{
        display: block;
        fill: module.$border;
        width: 1rem;
        height: 1rem;
        transition: all 200ms module.$ease;
      }
      &:hover{
        background: module.$base;
        transform: scale(1.2);
        svg{
          transform: scale(.9);
          fill: module.$white;
        }
      }
    }
  }
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const { reverse } = toRefs(props);
    const breakpoints = {
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
      769: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
    };
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      reverse,
      breakpoints,
    }
  },
}
</script>
